<template>
    <div :class="[ 'image-ratio', ...className ]">
        <img :src="src" v-bind="attrs">
    </div>
</template>

<script>
export default {
    props: {
        alt: String,
        lazy: String,
        priority: String,
        src: {
            type: String,
            required: true
        },
        className: {
            type: String,
            default: 'story__figure'
        },
    },
    computed: {
        attrs() {
            let _attrs = {
                alt: ``
            }
            if (this.lazy) {
                _attrs.preloading = 'lazy'
            }
            if (this.priority) {
                _attrs.fetchpriority = this.priority
            }
            if (this.alt) {
                _attrs.alt = this.alt
            }
            return _attrs
        },
    },
}
</script>